import { render, staticRenderFns } from "./CollectionProtocolParticipantCollectedSamples.vue?vue&type=template&id=6b629734&"
import script from "./CollectionProtocolParticipantCollectedSamples.vue?vue&type=script&lang=js&"
export * from "./CollectionProtocolParticipantCollectedSamples.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VApp,VBtn,VDataTable,VIcon})
